// redux/actions.ts
import { Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";
import { AppState } from "./reducer";
import {
  ADD_MERCHANT,
  RESET_STATE,
  SET_ERROR,
  SET_HAS_MERCHANT,
  SET_IS_DARK,
  SET_IS_PERSONAL,
  SET_USER,
  SET_WEBSOCKET_LOADED,
  SET_IS_CREATE_MERCHANT,
} from "./types";
import { GetProfileData } from "@services/models/Profile/GetProfileModel";
import { profileServices } from "@services/apis/Profile";

// Define ThunkAction type
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  AppState,
  unknown,
  any
>;

// Existing actions
export const setIsPersonal = (isPersonal: boolean) => ({
  type: SET_IS_PERSONAL,
  payload: isPersonal,
});

export const setIsDark = (isDark: boolean) => ({
  type: SET_IS_DARK,
  payload: isDark,
});

// Action to update the user object partially or fully, including merchantDetails
export const setUser = (user: Partial<AppState["user"]>) => ({
  type: SET_USER,
  payload: user,
});

// Action to reset the entire Redux state
export const resetState = () => ({
  type: RESET_STATE,
});

// Action to set websocket loaded
export const setWebsocketLoaded = (websocketLoaded: boolean) => {
  return {
    type: SET_WEBSOCKET_LOADED,
    payload: websocketLoaded,
  };
};

export const setHasMerchant = (hasMerchant: boolean) => ({
  type: SET_HAS_MERCHANT,
  payload: hasMerchant,
});

// New action creators for error handling
export const setError = (hasError: boolean) => ({
  type: SET_ERROR,
  payload: hasError,
});

export const setAddMerchant = (addMerchant: boolean) => ({
  type: ADD_MERCHANT,
  payload: addMerchant,
});

export const setIsCreateMerchant = (isCreateMerchant: boolean) => ({
  type: SET_IS_CREATE_MERCHANT,
  payload: isCreateMerchant,
});

// Asynchronous action to fetch user data from an API and dispatch setUser
export const fetchUserData = () => async (dispatch: Dispatch) => {
  try {
    const response = await profileServices.getProfile();
    const data: GetProfileData = response.data; // Explicitly type the data

    dispatch(
      setUser({
        userId: data.userId,
        emailId: data.emailId,
        userUUID: data.userUUID,
        profileImage: data.profileImage,
        currentMerchantId: data.currentMerchantId ? data.currentMerchantId : -1,
        firstName: data.firstName || "",
        merchantDetails: data.merchantDetails,
        personalBalance: data.personalBalance,
        merchantBalances: data.merchantBalances,
        whatsappNumber: data.whatsappNumber,
        countryCode: data.countryCode,
        p2pAccess: data.p2pAccess,
        kycStatuses: data.kycStatuses,
      })
    );

    dispatch(setHasMerchant(data.merchantDetails.length > 0));
  } catch (error) {
    console.error("Error fetching user data:", error);
    dispatch(setError(true)); // Dispatch the error action
  }
};
